/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramWhiteLabelsControllerFindOneQueryResponse,
  TelegramWhiteLabelsControllerFindOnePathParams,
  TelegramWhiteLabelsControllerFindOne404,
} from '../types/TelegramWhiteLabelsControllerFindOne.ts';

function getTelegramWhiteLabelsFindOneUrl(domain: TelegramWhiteLabelsControllerFindOnePathParams['domain']) {
  const res = { method: 'GET', url: `/api/telegram/white-labels/${domain}` as const };
  return res;
}

/**
 * {@link /api/telegram/white-labels/:domain}
 */
export async function telegramWhiteLabelsFindOne(
  domain: TelegramWhiteLabelsControllerFindOnePathParams['domain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramWhiteLabelsControllerFindOneQueryResponse,
    ResponseErrorConfig<TelegramWhiteLabelsControllerFindOne404>,
    unknown
  >({ method: 'GET', url: getTelegramWhiteLabelsFindOneUrl(domain).url.toString(), ...requestConfig });
  return res.data;
}
